import { __awaiter } from "tslib";
const STATS_ENDPOINT = '/ajax/stats/blueshiftEvent.php';
export default class BlueshiftStats {
    trackEventStats(event) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield fetch(STATS_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: (new URLSearchParams({ event }).toString()),
            });
        });
    }
}
